import { rootActions } from "../reducers/root.slice";
import { setStatus } from "../dom-utils";
import DatasetManager from "../lib/DatasetManager";
import { call, put } from "typed-redux-saga";
import ColumnUtils from "../utils/ColumnUtils";
import { TColumnName, TDataset } from "../types";
import MathUtils from "../utils/MathUtils";
import { CON_SCORE_COLUMN_PREFIX } from "../constants";
import RowUtils from "../utils/RowUtils";

export function* processRows(rows: TDataset, selectedDataset: string) {
  const errors = yield* call(DatasetManager.validateDataset, rows[0]);

  if (errors.length > 0) {
    yield* put(rootActions.initialiseError(errors));
    return;
  }

  const {
    methodColumns,
    continuousColumns,
    categoricalColumns,
    metaColumns,
    continuousPredictionColumns,
    categoricalPredictionColumns,
  } = ColumnUtils.findColumns(rows[0]);

  if (methodColumns.length === 0) {
    yield* put(rootActions.initialiseError(["No method columns found"]));
    return;
  }

  const conScores: Record<string, Record<string, string>> = {};
  const rowsSize = rows.length;
  let breakLoop = false;
  for (let i = 0; i < rowsSize; i++) {
    console.log(rows[i]);
    Object.keys(rows[i]).forEach((column) => {
      if (column.startsWith(CON_SCORE_COLUMN_PREFIX)) {
        const scoreKey = column.replace(CON_SCORE_COLUMN_PREFIX, "");
        const value = RowUtils.getValue(rows[i], column as TColumnName);

        if (value) {
          const splitScore = value
            .replaceAll(/\(/g, "")
            .replaceAll(/\)/g, "")
            .replaceAll("'", "")
            .split(", ");

          if (!(conScores as any)[scoreKey]) {
            (conScores as any)[scoreKey] = {};
          }

          (conScores as any)[scoreKey][splitScore[0]] = splitScore[1];
        } else {
          breakLoop = true;
        }
      }
    });

    if (breakLoop) {
      console.log("Went till row no.", i);
      break;
    }
  }

  const computedValues = MathUtils.findStandardDeviations(
    rows,
    continuousColumns
  );
  const selectedMethod = methodColumns[0];

  yield* put(
    rootActions.initialiseDone({
      rows,
      methodColumns,
      continuousColumns,
      categoricalColumns,
      metaColumns,
      continuousPredictionColumns,
      categoricalPredictionColumns,
      leftPanel: {
        selectedDataset,
        selectedMethod: methodColumns[0],
        selectedColumn: ColumnUtils.getDefaultColumn({
          categoricalColumns,
          categoricalPredictionColumns,
          continuousPredictionColumns,
          selectedMethod,
        }),
        columnsForHover: [],
      },
      computedValues,
      conScores,
    })
  );
}

function* initialiseSaga(action: ReturnType<typeof rootActions.initialise>) {
  const selectedDataset = action.payload;

  try {
    setStatus(`Initialising: loading dataset for ${selectedDataset}`);

    const source = DatasetManager.findSource(selectedDataset);

    if (!source) {
      setStatus(`Dataset not found for ${selectedDataset}`);
      return;
    }

    const rows = yield* call(DatasetManager.readSource, source);

    yield* call(processRows, rows, selectedDataset);
  } catch (error) {
    console.error(error);
    setStatus(`Error initialising: ${error.message}`);
  }
}

export default initialiseSaga;
